// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[dir] .othersSummary--Mf_iC {
  border-bottom: 1px dotted currentColor;
  cursor: help;
}

.othersTooltip--T0I8Y {
  max-width: min(420px, calc(100vw - 24px));
  white-space: normal;
  word-break: break-word;
  z-index: 1200;
}

[dir] .othersTooltip--T0I8Y {
  border-radius: 14px;
  padding: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/OthersSummary/styles.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;AAGf;;AAPA;EAKE,mBAAmB;EACnB,aAAa;AACf","sourcesContent":[".othersSummary {\n  border-bottom: 1px dotted currentColor;\n  cursor: help;\n}\n\n.othersTooltip {\n  max-width: min(420px, calc(100vw - 24px));\n  white-space: normal;\n  word-break: break-word;\n  z-index: 1200;\n  border-radius: 14px;\n  padding: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"othersSummary": `othersSummary--Mf_iC`,
	"othersTooltip": `othersTooltip--T0I8Y`
};
export default ___CSS_LOADER_EXPORT___;
